module.exports = __webpack_public_path__ + "/images/zalando-logo.f7ffce0.svg";